
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { UniversityResponse } from "../../models/dtos";

export const universitiesApi = createApi({
  reducerPath: 'universitiesApi',
  baseQuery: baseAuthQuery('Universities'),
  tagTypes: ['University'],
  endpoints: (builder) => ({
    getUniversities: builder.query<ApiResponse<UniversityResponse[]>, void>({
      query: () => "",
      providesTags: ['University'],
    }),
    getUniversityById: builder.query<ApiResponse<UniversityResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['University'],
    }),
    updateUniversity: builder.mutation<ApiResponse<UniversityResponse>, Partial<UniversityResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['University'],
    }),
    deleteUniversity: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['University'],
    }),
  }),
});
